/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { useEmptyStringFormat } from '@/hooks/fn';
import CTypeTab from '@/components/CTypeTab.vue';
// import localCache from '@/utils/localCache';
import useBeltScaleData from './hooks/useBeltScaleData';
export default defineComponent({
  name: 'BeltScaleData',
  components: {
    CTypeTab: CTypeTab
  },
  setup: function setup() {
    var params = ref({
      date: dayjs().format('YYYY/MM/DD'),
      type: 0 //时间类型 0日数据 1周数据 2月数据,
    });
    var confrimDate = function confrimDate(val) {
      params.value.date = val;
      getBeltScaleDataAsync();
    };
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var _dateRef$value;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              if (val === 4) {
                params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
              } else {
                params.value.date = dayjs().format('YYYY/MM/DD');
              }
              getBeltScaleDataAsync();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var _useBeltScaleData = useBeltScaleData(params),
      _useBeltScaleData2 = _slicedToArray(_useBeltScaleData, 2),
      beltScaleData = _useBeltScaleData2[0],
      getBeltScaleDataAsync = _useBeltScaleData2[1];
    var emptyStringFormat = useEmptyStringFormat();
    var summaryData = computed(function () {
      return beltScaleData.value.list;
    });
    onMounted(function () {
      getBeltScaleDataAsync();
    });
    // const router = useRouter();
    return {
      params: params,
      confirmType: confirmType,
      confrimDate: confrimDate,
      emptyStringFormat: emptyStringFormat,
      summaryData: summaryData,
      dateRef: dateRef
    };
  }
});